import { render, staticRenderFns } from "./SchoolOfCreativityDetail.vue?vue&type=template&id=f38eb614&scoped=true&"
import script from "./SchoolOfCreativityDetail.vue?vue&type=script&lang=js&"
export * from "./SchoolOfCreativityDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchoolOfCreativityDetail.vue?vue&type=style&index=0&id=f38eb614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38eb614",
  null
  
)

export default component.exports